import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {API_ENTITY_SHARE_CLASSES} from '../../../config/urls';
import {ShareClassDTO} from '@dto/entities/share-class-dto.model';
import {UrlService} from '@shared/services/url.service';

@Injectable({
  providedIn: 'root'
})
export class ShareClassService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  getShareClassesForClient(clientCode: string): Observable<ShareClassDTO[]> {
    const endpointUrl = this.urlService.buildUrl(API_ENTITY_SHARE_CLASSES, clientCode);
    return this.http.get<ShareClassDTO[]>(endpointUrl);
  }
}
